import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { FlowProvider } from "./context/FlowContext";
import { OutputLangProvider } from "./context/OutputLangContext";
import { Layout } from "./components/Layout";

import Landing from "./pages/Landing";
import QuestionSelect from "./pages/QuestionSelect";
import Wizard from "./pages/Wizard";
import Generating from "./pages/Generating";
import Teaser from "./pages/Teaser";
import Payment from "./pages/Payment";
import AccountCreate from "./pages/AccountCreate";
import Reading from "./pages/Reading";
import Explore from "./pages/Explore";
import MyReadings from "./pages/MyReadings";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import About from "./pages/About";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/q/:categoryId" element={<QuestionSelect />} />
        <Route path="/ask/:toolId" element={<Wizard />} />
        <Route path="/generating" element={<Generating />} />
        <Route path="/teaser/:readingId" element={<Teaser />} />
        <Route path="/pay/:readingId" element={<Payment />} />
        <Route path="/unlock/:readingId" element={<AccountCreate />} />
        <Route path="/reading/:readingId" element={<Reading />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/readings" element={<MyReadings />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <FlowProvider>
            <OutputLangProvider>
              <AppRouter />
              <Toaster position="top-center" richColors />
            </OutputLangProvider>
          </FlowProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
